import "./styles.scss"

import React, { useState } from "react"
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share"
import clsx from "clsx"

import { useLocale } from "context/locale"

import Button from "components/Button"

const ShareDropdown = ({ className, url }) => {
  const { t } = useLocale()

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className={clsx(
        "share-dropdown",
        isOpen && "share-dropdown--open",
        className
      )}
    >
      <Button
        className="button--small button--bordered-blue"
        onClick={() => setIsOpen(open => !open)}
      >
        {t("Share")}
      </Button>
      <ul className="share-dropdown__menu">
        <li>
          <FacebookShareButton url={url}>
            <img
              src={require("assets/icons/social-facebook-mobile.svg").default}
              alt=""
            />
          </FacebookShareButton>
        </li>
        <li>
          <TwitterShareButton url={url}>
            <img
              src={require("assets/icons/social-twitter-mobile.svg").default}
              alt=""
            />
          </TwitterShareButton>
        </li>
        <li>
          <LinkedinShareButton url={url}>
            <img
              src={require("assets/icons/social-linkedin-mobile.svg").default}
              alt=""
            />
          </LinkedinShareButton>
        </li>
        <li>
          <EmailShareButton url={url}>
            <img
              src={require("assets/icons/social-email-mobile.svg").default}
              alt=""
            />
          </EmailShareButton>
        </li>
      </ul>
    </div>
  )
}

export default ShareDropdown
